<template>
    <div>
        <heightConfig :data="data" @change="dataChange"/>
        <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item title="高级属性" name="1">
                <el-form-item :label="$t('顶部显示')">
                    <el-switch
                        v-model="data.showTop"
                        size="mini">
                    </el-switch>
                </el-form-item>
                <el-form-item :label="$t('顶部高度')" v-if="data.showTop">
                    <el-input-number v-model="data.topHeight" controls-position="right" size="mini"></el-input-number>
                </el-form-item>
                <el-form-item :label="$t('底部显示')">
                    <el-switch
                        v-model="data.showBottom"
                        size="mini">
                    </el-switch>
                </el-form-item>
                <el-form-item :label="$t('底部宽度')" v-if="data.showBottom">
                    <el-input-number v-model="data.bottomHeight" controls-position="right" size="mini"></el-input-number>
                </el-form-item>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>
  
<script>
import heightConfig from './components/height'
import mixin from './components/mixins'
export default {
    name: "config-verticalLayout",
    mixins: [mixin],
    inject: ["formDesign"],
    props: ['data'],
    components: {
        heightConfig
    },
    data() {
        return {
            shadowOptions: [
                { label: '总是', value: 'always' },
                { label: '悬浮显示', value: 'hover' },
                { label: '不显示', value: 'never' }
            ],
            activeNames: ['1']
        }
    },
    methods: {
        handleChange(){

        }
    }
}
</script>
<style lang="less" scoped>
::v-deep {
    .el-collapse-item__header{
        padding-left: 10px;
    }
    .el-collapse-item__arrow{
        position: absolute;
        left: 10px;
    }
}
</style>
  
  